<template>
  <div class="page-response">
    <div class="wrap">
      <a-page-header class="header" title="不正常航班证明" />
      <div class="inner" v-if="cmsData[type]" v-html="cmsData[type]"></div>
      <div class="btn-group">
        <a-button class="back" v-if="type === 'fail'" @click="back('alive')">返回上一页</a-button>
        <a-button class="sure" type="primary" @click="back('')">确定</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import './index'

export default {
  data () {
    return {
      type: 'success',
      cmsData: {}
    }
  },
  created () {
    const { type } = this.$route.query
    this.type = type || 'success'
    this.getCmsData()
  },
  methods: {
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then((res) => {
          this.cmsData = {
            success: res?.delaySuccess?.content || '',
            fail: res?.delayFail?.content || ''
          }
        })
      } catch (err) {}
    },
    back (type) {
      this.keepAlive = !!type
      this.$router.push({
        path: '/delay/segment'
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    to.meta.keepAlive = this.keepAlive
    next()
  }
}
</script>
